import { Card, Grid } from "@mui/material";
import { useState } from "react";
import AddNewAppDialog from "src/layouts/dialogs/AddNewAppDialog/AddNewAppDialog";

import EmptyIlustration from "./EmptyIlustration";
import TitleLabel from "./TitleLabel";

// ----------------------------------------------------------------------

export const EmptyApp = () => {
	const [open, setOpen] = useState(false);
	return (
		<Card sx={{ mt: { xs: 0, sm: 9 }, maxWidth: 1000 }}>
			<Grid container>
				<Grid item xs={12} sm={7}>
					<TitleLabel onClick={() => setOpen(true)} />
				</Grid>
				<Grid item xs={12} sm={5} justifyItems={"flex-end"}>
					<EmptyIlustration />
				</Grid>
			</Grid>
			<AddNewAppDialog onClose={() => setOpen(false)} show={open} />
		</Card>
	);
};

export default EmptyApp;
